import { Navigate, Route, Routes } from 'react-router-dom';

import { AdminTab } from './AdminTab';
import { HoursTimesheet } from './HoursTimesheet';
import { TIME_HOME } from './nav';

/**
 * Route table for the supervisor/admin time surfaces, rendered inside the
 * authenticated {@link import('../TenantShell').TenantShell}. `/` and any
 * unknown path fall back to the Hours & Timesheet landing surface.
 *
 * These routes are Manager/Admin only. The API is the authoritative gate (it
 * enforces the role and RLS server-side); the shell additionally hides this
 * whole surface from users it can positively identify as non-managers.
 */
export function TimeRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={TIME_HOME} replace />} />
      <Route path="/time" element={<HoursTimesheet />} />
      {/*
        The Employees and Salary rosters are now sections of the Admin hub. Their
        old top-level paths REDIRECT to the matching section rather than 404-ing
        to Hours, so existing bookmarks still land where the user meant to go.
      */}
      <Route path="/employees" element={<Navigate to="/admin/employees" replace />} />
      <Route path="/salary" element={<Navigate to="/admin/salary" replace />} />
      <Route path="/admin" element={<AdminTab />} />
      <Route path="/admin/:section" element={<AdminTab />} />
      <Route path="*" element={<Navigate to={TIME_HOME} replace />} />
    </Routes>
  );
}
